import styles from './GridMenu.module.scss.js';
import { jsx } from 'react/jsx-runtime';

function GridMenuSeparator() {
  return /*#__PURE__*/jsx("div", {
    className: styles['separator']
  });
}

export { GridMenuSeparator };
